import React from 'react';
import Reflux from 'reflux';
import FullScreenModalActions from 'flux/actions/FullScreenModalActions';
import FullScreenModalStore from 'flux/stores/FullScreenModalStore';
import classNames from 'classnames';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/**
 * Generic modal
 *
 */
export default React.createClass({
  mixins: [Reflux.connect(FullScreenModalStore, 'modalVisibility')],

  propTypes: {
    title: React.PropTypes.string,
    name: React.PropTypes.string.isRequired,
    headerClassName: React.PropTypes.string,
    onHide: React.PropTypes.func,
    closeButton: React.PropTypes.bool,
    display: React.PropTypes.bool, //Overwrite modal store state to manually display
  },

  getDefaultProps() {
    return {
      title: '',
      closeButton: true,
    };
  },

  displayName: 'FullscreenModal',

  render() {
    const { children, modalClassName, title, name, headerClassName } =
      this.props;

    if (!this.isVisible()) return null;

    return (
      <div className="fullscreen-modal-outer">
        <div
          // eslint-disable-next-line react/no-unknown-property
          show={this.isVisible()}
          // eslint-disable-next-line react/no-unknown-property
          onHide={this._handleClose}
          className={classNames(modalClassName, 'fullscreen-modal-inner')}
        >
          <div className={headerClassName}>
            <div key={`modal-header-${name}`}>{title}</div>
            <div className="fullscreen-modal-close-button">
              <Icon
                name="times"
                onClick={() => FullScreenModalActions.hide(name)}
              />
            </div>
          </div>
          <div
            key={`modal-body ${name}`}
            className="fullscreen-modal-body-wrapper"
          >
            {children}
          </div>
        </div>
      </div>
    );
  },

  isVisible() {
    const { display, name } = this.props;
    return display || this.state.modalVisibility.get(name) ? true : false;
  },
});
